import { Box, Chip, Typography } from "@mui/material";

const HeaderSection = ({ clientName, accountLead, sponsors, segmentation }) => {
  return (
    <Box
      sx={{
        mb: 3,
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        justifyContent: "space-between",
        alignItems: { xs: "flex-start", md: "center" },
        gap: 1,
      }}
    >
      <Box>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            color: "#003366",
            mb: 0.5,
          }}
        >
          {clientName} — Client 360 Overview
        </Typography>

        <Box sx={{ mb: 0.5 }}>
          <Typography sx={{ fontSize: "0.8rem", color: "#6c757d" }}>
            PFG Account Lead
          </Typography>
          <Typography sx={{ fontWeight: 600, fontSize: "0.9rem" }}>
            {accountLead}
          </Typography>
        </Box>

        <Box>
          <Typography sx={{ fontSize: "0.8rem", color: "#6c757d" }}>
            Sponsor / Decision Makers
          </Typography>
          <Typography sx={{ fontSize: "0.85rem", fontWeight: 500 }}>
            {(sponsors || []).join(", ")}
          </Typography>
        </Box>
      </Box>

      <Chip
        label={segmentation || "Client Segment"}
        color="primary"
        variant="outlined"
        sx={{ fontSize: "0.75rem", fontWeight: 500 }}
      />
    </Box>
  );
};

export default HeaderSection;
